import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

// Temporarily disable StrictMode to prevent double renders during development
// Enable it back in production builds
const isDevelopment = import.meta.env.DEV;

createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    {isDevelopment ? (
      <App />
    ) : (
      <StrictMode>
        <App />
      </StrictMode>
    )}
  </HelmetProvider>
);
